var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg360Degrees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 70,
    viewBox: "0 0 141 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2831 22.6927C25.2301 23.3947 24.5281 24.0968 23.124 24.7988C19.6138 26.554 16.1034 27.6071 12.9442 29.7133C6.62567 33.9256 6.62558 39.1911 13.2951 42.7014C19.9646 46.2117 26.9852 48.6689 34.3567 50.0731C43.4834 51.8282 52.6102 52.5303 62.088 53.5834C65.9493 53.9344 69.8107 53.5834 74.023 53.5834C74.023 50.7751 74.3739 47.9669 74.3739 44.4566C78.5863 49.371 82.0965 53.5834 85.9578 57.7957C82.7985 60.955 78.9373 64.8164 74.3739 69.7308C74.3739 66.2205 74.023 63.7633 74.023 61.306C63.8432 60.604 53.6633 59.9019 43.8345 58.8488C32.2506 57.4447 21.0177 55.3385 10.4869 49.722C5.92357 47.2648 0.658203 44.4566 0.658203 38.489C0.658203 32.1705 5.92357 29.3622 10.4869 26.905C15.0503 24.4478 19.9648 23.0437 24.8792 20.9375C25.5812 21.6396 25.9321 22.3416 26.2831 22.6927Z",
    fill: "url(#paint0_linear_2305_20681)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6275 59.5544C91.9254 52.5338 91.9253 52.8849 97.5417 51.8318C106.668 49.7256 115.795 47.2684 124.571 44.4601C128.432 43.407 132.294 40.5988 132.294 36.0354C132.294 31.472 128.081 29.7168 124.922 27.9617C122.465 26.5575 120.008 25.8555 117.55 24.8024C116.497 24.4514 115.795 23.3983 115.444 21.9941C123.869 23.7493 131.591 25.8555 137.91 32.174C141.771 36.0354 141.771 40.5988 137.91 44.4601C135.804 46.5663 133.347 48.3214 130.538 49.7256C118.954 55.6931 105.967 57.7993 92.6275 59.5544Z",
    fill: "url(#paint1_linear_2305_20681)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.498 0.578125C112.988 0.578125 110.18 3.38637 110.18 6.89668C110.18 10.407 112.988 13.2152 116.498 13.2152C120.008 13.2152 122.817 10.407 122.817 6.89668C122.817 3.38637 120.008 0.578125 116.498 0.578125ZM116.498 9.3539C115.094 9.3539 113.69 8.30081 113.69 6.54565C113.69 5.14153 114.743 3.7374 116.498 3.7374C117.902 3.7374 119.306 4.7905 119.306 6.54565C119.306 8.30081 117.902 9.3539 116.498 9.3539Z",
    fill: "url(#paint2_linear_2305_20681)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6626 27.2639C53.6626 33.2314 49.0993 37.7948 42.7808 37.7948C36.8134 37.7948 32.25 33.5825 32.25 27.6149H37.5154C37.8664 30.7742 39.9725 32.8804 43.1318 32.8804C46.291 32.8804 48.7483 30.4232 48.7483 26.9129C48.7483 23.4026 46.2912 21.2964 42.4299 21.2964H38.5684V20.2433L45.2381 10.0634H33.303V5.5H52.9607V6.55309L45.9401 17.435C50.1525 18.4881 53.6626 22.3495 53.6626 27.2639Z",
    fill: "url(#paint3_linear_2305_20681)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3943 26.9104C81.3943 33.229 76.4799 38.1434 69.8104 38.1434C62.7899 38.1434 58.2266 33.58 58.2266 26.9104C58.2266 24.1021 59.2796 20.5918 61.7368 16.3795L68.0553 5.14648H73.6716C69.8103 11.8161 68.4064 14.6243 67.0022 17.0815C68.4064 16.7305 69.4593 16.3795 70.8635 16.3795C76.4799 16.3795 81.3943 20.5918 81.3943 26.9104ZM76.1289 26.9104C76.1289 23.0491 73.3207 20.5918 69.8104 20.5918C65.9491 20.5918 63.492 23.0491 63.492 26.9104C63.492 30.4207 66.3001 33.229 69.8104 33.229C73.3207 33.229 76.1289 30.4207 76.1289 26.9104Z",
    fill: "url(#paint4_linear_2305_20681)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9043 21.2934C84.9043 11.1135 89.8186 4.79492 97.5412 4.79492C105.264 4.79492 110.178 11.1135 110.178 21.2934C110.178 31.4733 105.264 37.7918 97.5412 37.7918C89.8186 37.7918 84.9043 31.4733 84.9043 21.2934ZM104.913 21.2934C104.913 13.9217 102.105 9.70935 97.5412 9.70935C92.9778 9.70935 90.1697 13.9217 90.1697 21.2934C90.1697 28.665 92.9778 32.8774 97.5412 32.8774C102.105 33.2284 104.913 28.665 104.913 21.2934Z",
    fill: "url(#paint5_linear_2305_20681)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2305_20681",
    x1: 10.4033,
    y1: 87.4433,
    x2: 96.4897,
    y2: 40.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2305_20681",
    x1: 97.8492,
    y1: 73.1893,
    x2: 152.573,
    y2: 50.9518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2305_20681",
    x1: 111.623,
    y1: 17.8027,
    x2: 126.74,
    y2: 13.0452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2305_20681",
    x1: 34.6963,
    y1: 49.5182,
    x2: 61.6732,
    y2: 43.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2305_20681",
    x1: 60.8734,
    y1: 50.1216,
    x2: 89.9144,
    y2: 43.7045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2305_20681",
    x1: 87.7918,
    y1: 49.7701,
    x2: 119.195,
    y2: 42.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg360Degrees);
export default __webpack_public_path__ + "static/media/360degrees.82d3649ae967cc8e2f2229d54584a229.svg";
export { ForwardRef as ReactComponent };